<script setup>
  import Icon from "@/components/icons/Icon.vue";
</script>

<template>
  <Icon
    name="lock"
    class="jwx-wind-gauge__marker jwx-wind-gauge__marker--upgrade"
  />
</template>